import * as Yup from "yup";

export const adminProductSchema = Yup.object({
  name: Yup.string().trim().required("Product name is required").min(2).max(250),
  sku: Yup.string().trim(),
  price: Yup.number().typeError("Price is required").min(0).required("Price is required"),
  compareAtPrice: Yup.number().nullable().min(0),
  stock: Yup.number().integer().min(0).required("Stock is required"),
  category: Yup.string().trim().required("Primary category is required"),
  categories: Yup.array().of(Yup.string()),
  manufacturer: Yup.string().trim(),
  brand: Yup.string().trim(),
  description: Yup.string(),
  shortDescription: Yup.string().max(1000),
  tags: Yup.string(),
  images: Yup.array().of(Yup.string()),
  isActive: Yup.boolean(),
  isFeatured: Yup.boolean(),
  specifications: Yup.array().of(
    Yup.object({
      label: Yup.string().trim(),
      value: Yup.string().trim(),
    })
  ),
  variantOptions: Yup.array().of(
    Yup.object({
      name: Yup.string().trim().required("Option name required"),
      valuesText: Yup.string().trim(),
      colorValues: Yup.array().of(
        Yup.object({
          label: Yup.string().trim(),
          color: Yup.string().trim(),
        })
      ),
    })
  ),
  variants: Yup.array().of(
    Yup.object({
      sku: Yup.string(),
      price: Yup.number().nullable().min(0),
      stock: Yup.number().integer().min(0),
      image: Yup.string(),
      isDefault: Yup.boolean(),
      attributes: Yup.object(),
    })
  ),
});
